import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ExpertStories from "../Component/Explore Components/ExpertStories";
import FreelancerComment from "../Component/Explore Components/FreelancerComment";
import SubCatList from "../Component/Explore Components/SubCatList";
import GetStarted from "../Component/Get Started/GetStarted";
import BrowseSkill from "../Component/Homepage Components/BrowseSkills/BrowseSkill";
import "./css/Explore.css";
import { fadeInUp, tokens } from "../store/tokens";
import { bodyText, heading } from "../store/presetsNew";

const Explore = () => {
  const { id } = useParams();
  const [catSublistData, setCatSublistData] = useState([]);

  useEffect(() => {
    const formData = new FormData();
    formData.append("category_id", id);

    fetch(
      "https://aps.songjukti.com/profile/login/api_service/all_service_subcategory.php",
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((result) => setCatSublistData(Array.isArray(result) ? result : []))
      .catch((error) => console.log("ServiceApiError=> ", error));
  }, [id]);

  return (
    <Box sx={{ bgcolor: tokens.bg.page }}>
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          // was a bespoke "#E9F3F1 -> sand" gradient — tokens.color.tealLight
          // composited over white lands on almost the same soft mint tint,
          // so this now reuses the shared brand tint instead of a one-off hex.
          background: `linear-gradient(180deg, ${tokens.color.tealLight} 0%, ${tokens.bg.page} 100%)`,
          pt: { xs: 6, md: 9 },
          pb: { xs: 4, md: 6 },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "-120px",
            right: "-100px",
            width: 320,
            height: 320,
            borderRadius: "50%",
            background: `radial-gradient(circle, ${tokens.color.teal}33 0%, transparent 70%)`,
            pointerEvents: "none",
          }}
        />
        <Container sx={{ position: "relative" }}>
          <Stack
            alignItems="center"
            spacing={1.5}
            textAlign="center"
            sx={{ ...fadeInUp, animation: "fadeInUp .5s ease both" }}
            
          >
                   <Typography 
                   sx={{ ...heading("h2"), fontSize: { xs: "1.7rem", md: tokens.type.h2.fontSize } }}
                   >
              Trusted services and professionals, ready when you are
            </Typography>
                   <Typography sx={{ ...bodyText("body1"), maxWidth: 560 }}>
           
              Browse specialists by category and pick the one that fits your
              project.
            </Typography>
          </Stack>

          <Grid
            container
            spacing={2}
            justifyContent="center"
            sx={{ mt: { xs: 3, md: 5 } }}
          >
            {catSublistData?.map((element, index) => (
              <Grid
                item
                xs={6}
                sm={4}
                md={3}
                key={element.service_refer}
                sx={{
                  ...fadeInUp,
                  animation: "fadeInUp .5s ease both",
                  animationDelay: `${Math.min(index, 8) * 0.05}s`,
                }}
              >
                <SubCatList data={element} subCatKey={id} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Container sx={{ pb: { xs: 5, md: 7 } }}>
        <Box sx={{ mt: { xs: 4, md: 6 } }}>
          <ExpertStories id={id} />
        </Box>
        <FreelancerComment id={id} />
        <BrowseSkill id={id} />
        <GetStarted id={id} />
      </Container>
    </Box>
  );
};

export default Explore;